/**
 * Gets page name and transform it to the required pageType format
 */ const getPageType = (pageType)=>{
    const type = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
    switch(type){
        case 'productlisting':
            return 'product listing';
        case 'storelocator':
            return 'store locator';
        case 'appointmentfunnel':
            return 'appointment funnel';
        case 'purchasefunnel':
            return 'purchase funnel';
        case 'servicedetail':
            return 'service detail';
        case '':
            return 'unknown';
        default:
            return type;
    }
};

export { getPageType };
//# sourceMappingURL=get-page-type.js.map
